import { FormControl, FormGroup } from '@angular/forms';

export const FormUtils = {
    validateAllFormFields(formGroup: FormGroup) {
        Object.entries(formGroup.controls).forEach(([field, value]) => {
            if (value instanceof FormGroup) {
                this.validateAllFormFields(value);
            } else {
                this.validateFormField(formGroup, field);
            }
        });
    },

    validateFormField(formGroup: FormGroup, field: string) {
        const control = formGroup.get(field);

        if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
            control.updateValueAndValidity({ onlySelf: true });
        } else if (control instanceof FormGroup) {
            this.validateAllFormFields(control);
        }
    },

    isNestedFieldValid(formGroup: FormGroup, field: string) {
        const control = formGroup.get(field);
        return control ? control.valid : false;
    },

    isFieldInValid(formGroup: FormGroup, field: string) {
        const control = formGroup.get(field);
        return control
            ? control.invalid && (control.dirty || control.touched)
            : false;
    },

    isFieldPatternValid(formGroup: FormGroup, field: string) {
        const control = formGroup.get(field);
        return !!(
            control &&
            control.valid &&
            control.errors?.pattern
        );
    },

    displayFieldCss(formGroup: FormGroup, field: string) {
        const fieldInValid = this.isFieldInValid(formGroup, field);

        return {
            valid: !fieldInValid,
            invalid: fieldInValid,
        };
    },
};
